import styled from './detassistencias.module.css';
import { AuthContext } from '../../services/global';
import { useContext, useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import { Alerta } from '../../utils/functions';

function DetAssistencias() {
    const { dadosass } = useContext(AuthContext);
    const login = JSON.parse(localStorage.getItem("login"));
    const nomcli = login.nomcli;
    const Navigate = useNavigate('');
    const [itens, setitens] = useState([]);

    function Voltar(wpage) {
        Navigate(wpage);
    }

    async function GetItens() {
        await api.get(`assistencias/itens/?seqoco=${dadosass[0].seqoco}`)
            .then((response) => {
                if (!response.data.msg) {
                    setitens(response.data);
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }





    useEffect(() => {
        GetItens();
    }, [])


    return (
        <div className={styled.page}>
            <Menu menu="assistencia" />
            <div className={styled.container}>
                <Header page={`Nº ${dadosass[0].seqoco}`} />
                <div className={styled.content}>
                    <div className={styled.card}>
                        <div className={styled.card01}>
                            <div className={styled.card01content}>
                                <div className={styled.card01appdetalhes}>
                                    <div className={styled.card01header}>
                                        <a onClick={() => Voltar(dadosass[0].page)}>&lt; VOLTAR PARA ASSISTÊNCIAS</a>
                                    </div>
                                    <div className={styled.car01dados}>
                                        <div className={styled.card01dadoscontent}>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>NUMERO DA ASSISTÊNCIA</a>
                                                <span>{dadosass[0].seqoco}</span>
                                            </div>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>DATA ABERTURA</a>
                                                <span>{dadosass[0].datoco}</span>
                                            </div>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>TIPO DE ASSISTÊNCIA</a>
                                                <span>{dadosass[0].tipass}</span>
                                            </div>

                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>MOTIVO</a>
                                                <span>{dadosass[0].motass}</span>
                                            </div>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>NOME DO SOLICITANTE</a>
                                                <span>{nomcli}</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styled.card02}>
                            <div className={styled.card02header}>
                                <div className={styled.card02title}>
                                    <a>Situação da Assistência</a>
                                    <div className={styled.card02line}></div>
                                </div>
                            </div>
                            <div className={styled.card02content}>
                                <div className={styled.card02app}>
                                    <div className={styled.card02situa}>
                                        <div className={styled.card02status}>
                                            {dadosass[0].status == 'EM TRANSPORTE' ? <div className={styled.statustrans}></div> : null}
                                            {dadosass[0].status == 'PRODUZINDO' ? <div className={styled.statusprod}></div> : null}
                                            {dadosass[0].status == 'ENTREGUE' ? <div className={styled.statusentregue}></div> : null}
                                            {dadosass[0].status == 'PENDENTE' ? <div className={styled.statusanalise}></div> : null}
                                        </div>
                                        <div className={styled.card02statuslabel}>
                                            <a>{dadosass[0].status}</a>
                                            <span>{dadosass[0].status == 'ENTREGUE' ? dadosass[0].datenc : ''}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className={styled.card03}>
                            <div className={styled.card03header}>
                                <div className={styled.card03title}>
                                    <a>Produtos</a>
                                    <div className={styled.card03line}></div>
                                </div>
                            </div>
                            <div className={styled.card03content}>
                                <div className={styled.card03app}>
                                    {itens.map((item) => {
                                        return (
                                            <div className={styled.card03item}>
                                                <img src={item.urlimg} alt="" className={styled.card03itemimg} />
                                                <div className={styled.card03itemcontent}>
                                                    <a>{item.nompro}</a>
                                                    <span>{item.qtdpro} unidade</span>
                                                    
                                                    <span></span>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    )
}


export default DetAssistencias;